import { PUBLIC_BASE_URL } from '$env/static/public';
import type { AdminCategoryFilters, AdminProductFilters } from '$lib/types';

export const defaultToastTimeout = 4000;

export const defaultProductPaginationSize = 8;

export const mobileBreakPoint = 640;

export const imageCacheControl = '28800'; // 8 hrs

export const fallbackImage = '/logos/Logo_BOUTIQUE MISTICA_transparent-01.png';

export const defaultAdminProductFilters: AdminProductFilters = {
	coincidence: '',
	published: false,
	lead: false,
	archived: false,
	categories: []
};
export const defaultAdminCAtegoryFilters: AdminCategoryFilters = {
	name: '',
	lead: false,
	archived: false
};

export const imageConf = {
	product: {
		small: { size: 100, storage: 'product-small' },
		medium: { size: 320, storage: 'product-medium' },
		large: { size: 800, storage: 'product-large' }
	},
	category: {
		small: { size: 100, storage: 'category-small' },
		medium: { size: 400, storage: 'category-medium' },
		large: { size: 1000, storage: 'category-large' }
	}
};

export const shippingMethods = [
	{
		basePrice: 19000,
		image_url: '/shipping_methods/estafeta.png',
		name: 'estafeta',
		option: 1,
		extraKiloPrice: 5000,
		maximumBaseKilos: 5
	}
	// { price: 15000, image_url: '/shipping_methods/dhl-alter.png', name: 'DHL', option: 1 },
	// { price: 17000, image_url: '/shipping_methods/FedEx.png', name: 'FedEx', option: 2 },
	// { price: 10000, image_url: '/shipping_methods/ups.png', name: 'Ups', option: 3 }
];

export const orderStatus = [
	'Pendiente de revisión',
	'Rechazado',
	'Confirmado',
	'Empaquetado',
	'Enviado',
	'Entregado'
] as const;

export const responseFailURL = `${PUBLIC_BASE_URL}/checkout/error`;
export const responseSuccessURL = `${PUBLIC_BASE_URL}/checkout/exito`;

export const mexTimezones = [
	'America/Cancun',
	'America/Chihuahua',
	'America/Hermosillo',
	'America/Matamoros',
	'America/Mazatlan',
	'America/Merida',
	'America/Mexico_City',
	'America/Monterrey',
	'America/Ojinaga',
	'America/Tijuana'
] as const;

export const defaultFiservErrorMessage = 'Puedes probar con otra tarjeta.';
export const issuerRejections: {
	IssuerResponseCode: string;
	ProcessorResponseMessage: string;
	description: string;
	softVsHard: 'Soft' | 'Hard';
	comment: string;
}[] = [
	{
		IssuerResponseCode: '01',
		ProcessorResponseMessage: 'N:01:01-REFERRAL',
		description: 'Refer to card issuer',
		softVsHard: 'Hard',
		comment: 'Referir'
	},
	{
		IssuerResponseCode: '02',
		ProcessorResponseMessage: 'N:01:02-REFERRAL',
		description: 'Refer to special conditions for card issuer',
		softVsHard: 'Hard',
		comment: 'Referir'
	},
	{
		IssuerResponseCode: '03',
		ProcessorResponseMessage: 'N:03:03-INVLD MER ID',
		description: 'Invalid merchant Hard',
		softVsHard: 'Hard',
		comment: 'Comercio Invalido'
	},
	{
		IssuerResponseCode: '04',
		ProcessorResponseMessage: 'N:60:04-HOLD-CALL CTR',
		description: 'Pick-up card Soft',
		softVsHard: 'Soft',
		comment: 'Retener Tarjeta'
	},
	{
		IssuerResponseCode: '05',
		ProcessorResponseMessage: 'N:51:05-DECLINED',
		description: 'Do not honor',
		softVsHard: 'Soft',
		comment: 'Llame a su banco'
	},
	{
		IssuerResponseCode: '06',
		ProcessorResponseMessage: 'N:01:06-DECLINED',
		description: 'Error',
		softVsHard: 'Soft',
		comment: 'Error'
	},
	{
		IssuerResponseCode: '07',
		ProcessorResponseMessage: 'N:60:07-HOLD-CALL',
		description: 'CTR	Pick-up card, special condition',
		softVsHard: 'Hard',
		comment: 'Retener Tarjeta'
	},
	{
		IssuerResponseCode: '12',
		ProcessorResponseMessage: 'N:12:12-INV TRAN',
		description: 'Invalid transaction',
		softVsHard: 'Soft',
		comment: 'Transacción Invalida'
	},
	{
		IssuerResponseCode: '13',
		ProcessorResponseMessage: 'N:13:13-INV AMT',
		description: 'Invalid amount',
		softVsHard: 'Hard',
		comment: 'Monto Invalido'
	},
	{
		IssuerResponseCode: '14',
		ProcessorResponseMessage: 'N:14:14-INV ACCT NUM',
		description: 'Invalid card number',
		softVsHard: 'Soft',
		comment: 'Numero invalido'
	},
	{
		IssuerResponseCode: '15',
		ProcessorResponseMessage: 'N:51:15-DECLINED',
		description: 'No such issuer',
		softVsHard: 'Hard',
		comment: 'Emisor No disponible'
	},
	{
		IssuerResponseCode: '30',
		ProcessorResponseMessage: 'N:91:30-PLEASE RETRY',
		description: 'Format error',
		softVsHard: 'Hard',
		comment: 'Reintente'
	},
	{
		IssuerResponseCode: '33',
		ProcessorResponseMessage: 'N:54:33-EXPIRED CARD',
		description: 'Expired Card',
		softVsHard: 'Hard',
		comment: 'Tarjeta Expirada'
	},
	{
		IssuerResponseCode: '39',
		ProcessorResponseMessage: 'N:51:39-DECLINED',
		description: 'No credit account',
		softVsHard: 'Soft',
		comment: 'Cuenta Invalida'
	},
	{
		IssuerResponseCode: '41',
		ProcessorResponseMessage: 'N:60:41-HOLD-CALL CTR',
		description: 'Lost card',
		softVsHard: 'Hard',
		comment: 'Tarjeta Perdida'
	},
	{
		IssuerResponseCode: '43',
		ProcessorResponseMessage: 'N:60:43-HOLD-CALL CTR',
		description: 'Stolen card, pick-up',
		softVsHard: 'Hard',
		comment: 'Tarjeta Robada'
	},
	{
		IssuerResponseCode: '51',
		ProcessorResponseMessage: 'N:51:51-DECLINED',
		description: 'Not sufficient funds',
		softVsHard: 'Soft',
		comment: 'Fondos Insuficientes'
	},

	{
		IssuerResponseCode: '12',
		ProcessorResponseMessage: 'N:12:12-INV TRAN',
		description: 'Invalid transaction',
		softVsHard: 'Soft',
		comment: 'Transacción Invalida'
	},
	{
		IssuerResponseCode: '54',
		ProcessorResponseMessage: 'N:54:54-EXPIRED CARD',
		description: 'Expired card',
		softVsHard: 'Soft',
		comment: 'Tarjeta Expirada'
	},
	{
		IssuerResponseCode: '55',
		ProcessorResponseMessage: 'N:55:55-INCORRECT PIN',
		description: 'Incorrect personal identification number',
		softVsHard: 'Soft',
		comment: 'Pin Incorrecto'
	},
	{
		IssuerResponseCode: '57',
		ProcessorResponseMessage: 'N:57:57-TXN NOT ALLOW',
		description: 'Transaction not permitted to cardholder',
		softVsHard: 'Hard',
		comment: 'Operación no permitida al tarjetahabiente'
	},
	{
		IssuerResponseCode: '58',
		ProcessorResponseMessage: 'N:63:58-SERV NOT ALLOWED',
		description: 'Transaction not permitted to terminal',
		softVsHard: 'Soft',
		comment: 'Operación no permitida al comercio'
	},
	{
		IssuerResponseCode: '61',
		ProcessorResponseMessage: 'N:51:61-TRY AGAIN LATER',
		description: 'Exceeds withdrawal amount limit',
		softVsHard: 'Soft',
		comment: 'Limite de retiro excedido'
	},
	{
		IssuerResponseCode: '62',
		ProcessorResponseMessage: 'N:63:62-SER NOT ALLOW',
		description: 'Restricted card',
		softVsHard: 'Hard',
		comment: 'Tarjeta Restringida'
	},
	{
		IssuerResponseCode: '65',
		ProcessorResponseMessage: 'N:51:65-TRY AGAIN LATER',
		description: 'Exceeds withdrawal frequency limit',
		softVsHard: 'Soft',
		comment: 'Limite de retiro excedido'
	},
	{
		IssuerResponseCode: '68',
		ProcessorResponseMessage: 'N:91:68-PLEASE RETRY',
		description: 'Response received too late',
		softVsHard: 'Soft',
		comment: 'Tiempo excedido de respuesta'
	},
	{
		IssuerResponseCode: '75',
		ProcessorResponseMessage: 'N:75:75-PIN RETRY MAX',
		description: 'Allowable number of PIN tries exceeded',
		softVsHard: 'Soft',
		comment: 'Intento de PIN excedido'
	},
	{
		IssuerResponseCode: '91',
		ProcessorResponseMessage: 'N:91:91-PLEASE RETRY',
		description: 'Issuer or switch is inoperative',
		softVsHard: 'Soft',
		comment: 'Emisor No disponible'
	},
	{
		IssuerResponseCode: '92',
		ProcessorResponseMessage: 'N:91:92-PLEASE RETRY',
		description: 'Financial institution or intermediate network',
		softVsHard: 'Soft',
		comment: 'Error de red'
	},
	{
		IssuerResponseCode: '94',
		ProcessorResponseMessage: 'N:94:94-DUPLICATE TRAN',
		description: 'Duplicate transmission',
		softVsHard: 'Soft',
		comment: 'Transacción duplicada'
	},
	{
		IssuerResponseCode: '96',
		ProcessorResponseMessage: 'N:CE:96-SYSTEM PROBLEM',
		description: 'System malfunction',
		softVsHard: 'Soft',
		comment: 'Error de sistema'
	}
];

export const platformRejections = [
	{ code: 'N:5018', description: 'No transaction found for void', comment: '' },
	{ code: 'N:2303', description: 'Invalid credit card number', comment: '' },
	{ code: 'N:30051', description: 'Transaction timed out', comment: '' },
	{
		code: 'N:5103',
		description: 'Cardholder did not return from ACS',
		comment: 'Tarjetahabiente no completo la autenticación'
	},
	{ code: 'N:2304', description: 'Invalid or expired card expiry date', comment: '' },
	{ code: 'N:5101', description: '3D Secure authentication failed', comment: 'Autenticación fallida' },
	{ code: 'N:5315', description: 'Transaction is already in state DECLINED', comment: '' },
	{ code: 'N:5005', description: 'FRAUD - Purchase limit exceeded', comment: '' },
	{ code: 'N:5002', description: 'brand not supported', comment: 'Tarjeta no Soportada' },
	{ code: 'N:5993', description: 'Cancelled by user', comment: 'Cancelada por el usuario' },
	{ code: 'N:30031', description: 'No terminal setup', comment: '' },
	{ code: 'N:7778', description: 'Transaction timed out', comment: '' },
	{ code: 'N:50698', description: 'Incompatible referenced transaction', comment: '' },
	{ code: 'N:5003', description: 'The order already exists in the database', comment: 'La orden ya existe' },
	{ code: 'N:5005', description: 'FRAUD - Duplicate lockout', comment: 'Bloqueo por duplicidad' },
	{ code: 'N:5009', description: 'No transaction to return found', comment: '' },
	{ code: 'N:7777', description: 'System too busy', comment: '' },
	{ code: 'N:5996', description: 'Invalid card type', comment: '' },
	{ code: 'N:95001', description: 'Currency not supported for Local cards', comment: '' },
	{ code: 'N:5995', description: 'Order too old to be referenced', comment: '' },
	{ code: 'N:50004', description: 'Invalid transaction request', comment: '' },
	{ code: 'N:96000', description: 'Installment not supported', comment: 'Cuotas no soportadas (MSI)' },
	{ code: 'N:5994', description: 'The selected brand does not match the card number.', comment: '' },
	{ code: 'N:5102', description: 'ECI 7', comment: 'Sin autenticar' },
	{ code: 'N:50687', description: 'Split Authentication not supported', comment: '' },
	{ code: 'N:5022', description: 'Not voidable', comment: '' },
	{ code: 'N:5014', description: 'Validation problem', comment: '' },
	{ code: 'N:10601', description: 'Total amount passed is more than the Return/Void amount.', comment: '' },
	{ code: 'N:10501', description: 'PostAuth already performed', comment: '' }
];
